import React from "react";
import { useHistory } from "react-router-dom";
import Header from "../components/Header";
import styles from "./DreamStream.module.css";
import downloadAppleIcon from "assets/Download_App_Store.svg";
import downloadGooglePlay from "assets/Google_Play_Button.svg";
import mobile from "mobileBridge";
import { useAccount } from "../utils/AccountInfoContext";
import { useMembership } from "MembershipPage/useMembershipPage";
import { useTranslation } from "react-i18next";

export function DreamStream() {
  const {t} = useTranslation();
  const history = useHistory();
  const { accountData, activeUser } = useAccount();
  const contacts = accountData?.contacts;

  const isMobile = mobile.isApp();
  const isIOS = (mobile.getPlatform() || "").toLowerCase() == "ios";
  const isAndroid =
    (mobile.getPlatform() || "").toLowerCase() == "and" ||
    (mobile.getPlatform() || "").toLowerCase() == "android";

  const { data: membershipData } = useMembership();

  const activeUserEmail = contacts?.find(
    (contact) => contact.contactId === activeUser?.contactId
  )?.email;

  const googleUrl =
    "https://play.google.com/store/apps/details?id=today.dreamstream.www";
  const appleUrl =
    "https://apps.apple.com/us/app/dreamstream-by-wwg/id6444070428";
  const dreamStreamUrl = "https://www.dreamstream.today/login";

  const handleHeaderBackClick = () => {
    if (history.length > 1) {
      history.goBack();
    } else {
      history.push("/");
    }
  };

  const handleGoToDreamStream = () => {
    mobile.isApp()
      ? mobile.openLink(dreamStreamUrl)
      : window.open(dreamStreamUrl, "_blank");
  };

  const membershipType = membershipData?.current?.title;

  return (
    <div className={styles.container}>
      <Header
        header={t("Settings")}
        className={styles.header}
        onClick={handleHeaderBackClick}
      />

      <div className="content">
        {membershipType !== "Basic Membership" ? (
          <>
            <h3 className={styles.title}>{t("Welcome to DreamStream")}</h3>
            <div className={styles.description}>
              <p className={styles.text}>
                {t("You're automatically registered for DreamStream")}
              </p>
              <p className={styles.text}>
                {t("You'll receive an email")}{" "}
                <strong>{activeUserEmail}</strong>{" "}
                {t("to get started as soon as your account is ready")}
              </p>
            </div>

            <div className={styles.buttonsContainer}>
              {!isMobile && (
                <div
                  className={styles.goToButton}
                  onClick={handleGoToDreamStream}
                >
                  {t("Go To DreamStream")}
                </div>
              )}
              <div className={styles.buttonContainer}>
                {(!isMobile || (isMobile && isIOS)) && (
                  <img
                    src={downloadAppleIcon}
                    alt="Download on App Store"
                    onClick={() => {
                      mobile.isApp()
                        ? mobile.openLink(appleUrl)
                        : window.open(appleUrl, "_blank");
                    }}
                    className={styles.downloadBtn}
                  />
                )}
                {(!isMobile || (isMobile && isAndroid)) && (
                  <img
                    src={downloadGooglePlay}
                    alt="Download on Google Store"
                    onClick={() => {
                      mobile.isApp()
                        ? mobile.openLink(googleUrl)
                        : window.open(googleUrl, "_blank");
                    }}
                    className={styles.downloadBtn}
                  />
                )}
              </div>
            </div>
          </>
        ) : (
          <>
            <div className={styles.description}>
              <p className={styles.text}>{t("DreamStream only for Premier")}</p>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
